define('home/views/formatting/FormattingButtonsView',[
    'underscore',
    'backbone',

    'home/models/formatting/LinkPopover',
    'home/views/formatting/LinkPopoverView',

    'home/templates/formattingButtons',
], function (
    _,
    Backbone,

    LinkPopoverModel,
    LinkPopoverView,

    formattingButtonsTemplate
) {
    'use strict';

    var parent = Backbone.View;
    var parentProto = parent.prototype;

    var FormattingButtonsView = parent.extend({
        template: formattingButtonsTemplate,

        events: {
            'click [data-action=toggle-formatting]': 'onFormattingClick',
            'click [data-action=insert-link]': 'onInsertLinkClick',
        },

        initialize: function (options) {
            this.getPostbox = options.getPostbox;

            this.linkModel = new LinkPopoverModel();
        },

        render: function () {
            this.$el.html(this.template());

            if (this._popoverView)
                return this;

            this._popoverView = new LinkPopoverView({
                $target: this.$('[data-action=insert-link]'),
                model: this.linkModel,
            });

            this.listenTo(this._popoverView, {
                hide: function () {
                    // Attempt to restore the textarea selection.
                    // This is necessary as the selection is lost when the
                    // popover is opened (because the popover has its own
                    // input fields).
                    // If the popover is closed, and the user did not close
                    // it by focusing on another input, the textarea selection
                    // should be restored.
                    var activeElement = window.document.activeElement;
                    if (!activeElement || activeElement.tagName !== 'INPUT')
                        this.getPostbox().textarea.restoreSelection();
                },
                submit: function (data) {
                    this.insertFormattingTags('link', {
                        url: data.url,
                        text: data.text,
                    });

                    this._popoverView.hide();

                    // Reset the link model
                    this.linkModel.clear();
                },
            });

            return this;
        },

        remove: function () {
            if (this._popoverView)
                this._popoverView.remove();

            parentProto.remove.apply(this, arguments);
        },

        insertFormattingTags: function (operation, options) {
            var textarea = this.getPostbox().textarea;

            if (operation === 'link') {
                var wrappedText = '<a href="' + _.escape(options.url) + '">' +
                    this.constructor.escapeCommentHtml(options.text) +
                    '</a>';
                textarea.insertAtCursor(wrappedText);
            } else {
                var tagName = FormattingButtonsView.FORMATTING_TAGS[operation];

                if (!tagName)
                    throw new Error('Invalid formatting operation: ' + operation);

                textarea.insertAroundSelection('<' + tagName + '>', '</' + tagName + '>');
            }
        },

        onFormattingClick: function (evt) {
            var kind = evt.currentTarget.getAttribute('data-formatting');
            this.insertFormattingTags(kind);
        },

        onInsertLinkClick: function () {
            var textarea = this.getPostbox().textarea;
            var text = textarea.getSelected();

            var attrs = {
                originalText: text,
            };

            // Override the text if it does not look like the user has customized it
            var linkText = this.linkModel.get('text');
            if (!linkText || linkText === this.linkModel.get('originalText'))
                attrs.text = text;

            this.linkModel.set(attrs);

            this._popoverView.show();
        },
    }, {
        FORMATTING_TAGS: {
            bold: 'strong',
            blockquote: 'blockquote',
            italics: 'em',
            underline: 'u',
        },

        // Selectively escapes text. It attempts to avoid escaping if
        // the server will be able to escape the text without issue.
        //
        // > escapeCommentHtml('1 < 2, 3<4')
        // '1 < 2, 3&lt;4'
        // > escapeCommentHtml('a&b, c & d')
        // 'a&amp;b, c & d'
        //
        // WARNING: This function is solely intended for use with text which will
        // be submitted to the server as part of a comment or discussion body.
        escapeCommentHtml: function (text) {
            return text
                    .replace(/&(?=\S)/g, '&amp;')
                    .replace(/<(?=\S)/g, '&lt;');
        },
    });

    return FormattingButtonsView;
});

